import React, { useContext } from "react";
import "./Revenue.scss";
import { AppContext } from "../../App";
import formatNumberWithCommas from "../format/formatNumberWithCommas";
import { ProcessData } from "../format/ProcessMonthYear";
import { convertAndSortKeys } from "../format/SortMonth";
import { formatMonthWithLeadingZero } from "../format/FormatLeadingZeroMonth";

const Revenue = () => {
  const { billData } = useContext(AppContext);
  const currentDate = new Date();
  let currentMonth = currentDate.getMonth() + 1;
  let currentYear = currentDate.getFullYear();
  const { totalPaymentSums, currentMonthDataLength } = ProcessData(billData);

  const mergedData = {};

  for (const key in totalPaymentSums) {
    if (
      totalPaymentSums.hasOwnProperty(key) &&
      currentMonthDataLength.hasOwnProperty(key)
    ) {
      mergedData[key] = {
        total: totalPaymentSums[key],
        ProductionQuantityLimits: currentMonthDataLength[key],
      };
    }
  }

  const FormatMonthYears = `${formatMonthWithLeadingZero(
    currentMonth
  )}-${currentYear}`;

  return (
    <div className="revenue-container">
      <div className="highlighted-month">
        {Object.entries(convertAndSortKeys(mergedData)).map(
          ([monthYear, { total, ProductionQuantityLimits }]) =>
            monthYear === FormatMonthYears ? (
              <div className="month-data" key={monthYear}>
                <div className="frame-content-currentmonht">
                  <p>Month: {monthYear}</p>
                </div>
                <div className="frame-content-currentmonht">
                  <p>Quantity: {ProductionQuantityLimits}</p>
                </div>
                <div className="frame-content-currentmonht">
                  <p>Total: {formatNumberWithCommas(total)}</p>
                </div>
              </div>
            ) : (
              ""
            )
        )}
      </div>
      <div className="frame-table">
        <table className="revenue-table">
          <tbody>
            {Object.entries(convertAndSortKeys(mergedData)).map(
              ([monthYear, { total, ProductionQuantityLimits }]) =>
                total !== 0 ? (
                  <tr key={monthYear}>
                    <td>{monthYear}</td>
                    <td>{ProductionQuantityLimits}</td>
                    <td>{formatNumberWithCommas(total)}</td>
                  </tr>
                ) : (
                  ""
                )
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Revenue;
